import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import theme from 'styled-theming';
import { connect } from 'react-redux';
import { ConnectedRouter, push } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { history } from './store/configureStore';
import HubLive from './containers/HubLive';
import HubFavourites from './containers/HubFavourites';
import * as types from './constants';
import './styles/fonts.css';
import ConfigManager from './common/configManager/configManager';
import theme from 'theme'; //eslint-disable-line


//${process.env.THEME}

class App extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.theme = Object.assign({}, theme);
    const { actions } = this.props;
    const { initDictionary, updateLocalStorage, updateSessionCounter } = actions;
    initDictionary();
    updateLocalStorage();
    updateSessionCounter();
  }

  getChildContext = () => ({
    breakpoints: this.dynamicBreakPoint(process.env.REACT_APP_SITE),
  });

  dynamicBreakPoint = (site) => {
    if (site === 'gazzetta') {
      return [320, 599, 1024, 1440];
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return [767, 767, 980, 1440];
    } else if (site === 'corriere') {
      return [320, 767, 767, 1440];
    } else {
      return [320, 599, 1024, 1440];
    }
  };

  render() {
    const {
      actions, allSportsFilter, availableSportsCounter, isLoaded, sortedSports, loadedAll,
      competitions, favouritesCounter, filterDate, location, availableSports, dictionary,
      selectedSportsCounter, filterLive, yesterday, today, tomorrow, showTooltip, liveCounter,
      highlightedCompetitions, isDifferentTZS, promohighlighted, liveSoccerMatches,
    } = this.props;
    return (
      <ThemeProvider theme={this.theme}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route
              exact
              path={ConfigManager.getRoute('hublive', process.env.REACT_APP_SITE)}
              render={() => (
                <HubLive
                  actions={actions}
                  competitions={competitions}
                  favouritesCounter={favouritesCounter}
                  filterDate={filterDate}
                  location={location}
                  availableSports={availableSports}
                  sortedSports={sortedSports}
                  dictionary={dictionary}
                  allSportsFilter={allSportsFilter}
                  availableSportsCounter={availableSportsCounter}
                  selectedSportsCounter={selectedSportsCounter}
                  filterLive={filterLive}
                  showTooltip={showTooltip}
                  liveCounter={liveCounter}
                  highlightedCompetitions={highlightedCompetitions}
                  isLoaded={isLoaded}
                  loadedAll={loadedAll}
                  isDifferentTZS={isDifferentTZS}
                  promohighlighted={promohighlighted}
                  liveSoccerMatches={liveSoccerMatches}
                />)}
            />
            <Route
              path={ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE)}
              render={() => (
                <HubFavourites
                  actions={actions}
                  favouritesCounter={favouritesCounter}
                  location={location}
                  yesterday={yesterday}
                  today={today}
                  tomorrow={tomorrow}
                  dictionary={dictionary}
                  isDifferentTZS={isDifferentTZS}
                />
              )}
            />
          </Switch>
        </ConnectedRouter>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  actions: PropTypes.any,
  allSportsFilter: PropTypes.bool,
  competitions: PropTypes.any,
  favouritesCounter: PropTypes.number,
  filterDate: PropTypes.object,
  location: PropTypes.any,
  dictionary: PropTypes.any,
  filterLive: PropTypes.bool,
  availableSportsCounter: PropTypes.number,
  liveSoccerMatches: PropTypes.number,
  availableSports: PropTypes.any,
  sortedSports: PropTypes.any,
  selectedSportsCounter: PropTypes.number,
  yesterday: PropTypes.any,
  today: PropTypes.any,
  tomorrow: PropTypes.any,
  showTooltip: PropTypes.bool,
  liveCounter: PropTypes.any,
  highlightedCompetitions: PropTypes.any,
  isLoaded: PropTypes.bool,
  loadedAll: PropTypes.any,
  isDifferentTZS: PropTypes.any,
  promohighlighted: PropTypes.any,
};

export default connect(
  state => ({
    competitions: state.sportsReducer.get('filteredCompetitions'),
    highlightedCompetitions: state.sportsReducer.get('filteredHighlightedCompetitions'),
    favouritesCounter: state.localStorageReducer.favouritesCounter,
    filterDate: state.sportsReducer.get('filterDate'),
    location: state.router.location,
    dictionary: state.dictionaryReducer.dictionary,
    availableSports: state.sportsReducer.get('availableSports'),
    sortedSports: state.sportsReducer.get('sortedSports'),
    allSportsFilter: state.sportsReducer.get('allSports'),
    availableSportsCounter: state.sportsReducer.get('availableSportsCounter'),
    liveSoccerMatches: state.sportsReducer.get('liveSoccerMatches'),
    selectedSportsCounter: state.sportsReducer.get('selectedSportsCounter'),
    filterLive: state.sportsReducer.get('live'),
    yesterday: state.favouritesReducer.get('yesterday'),
    today: state.favouritesReducer.get('today'),
    tomorrow: state.favouritesReducer.get('tomorrow'),
    showTooltip: state.tooltipReducer.showTooltip,
    liveCounter: state.sportsReducer.get('liveCompetitionsCounter'),
    isLoaded: state.sportsReducer.get('loaded'),
    loadedAll: state.sportsReducer.get('loadedAll'),
    isDifferentTZS: state.localStorageReducer.isDifferentTZS,
    promohighlighted: state.sportsReducer.get('promohighlighted'),
  }),
  dispatch => ({
    actions: {
      push: url => dispatch(push(url)),
      getSportsList: (date, pref) => dispatch({ type: types.GET_SPORTS_LIST_REQUEST, date, pref }),
      filterLive: live => dispatch({ type: types.FILTER_LIVE, live }),
      getCompetitionsList: (date, sportId, live, pref) => dispatch({
        type: types.GET_COMPETITIONS_LIST_REQUEST,
        date,
        sportId,
        live,
        pref,
      }),
      sportFilter: (sportId, isSelected) => dispatch({ type: types.FILTER_SPORT, sportId, isSelected }),
      allSportsFilter: allSports => dispatch({ type: types.FILTER_ALL_SPORTS, allSports }),
      favouriteGame: (sportId, gameId) => dispatch({ type: types.FAVOURITES_MATCH, sportId, gameId }),
      filterDate: date => dispatch({ type: types.FILTER_DATETIME, date }),
      clearStorage: () => dispatch({ type: types.CLEAR_LOCAL_STORAGE }),
      initDictionary: () => dispatch({ type: types.INIT_DICTIONARY }),
      getYesterdayTomorrow: urlParams => dispatch({ type: types.GET_YESTERDAY_TOMORROW_REQUEST, urlParams }),
      updateLocalStorageDate: date => dispatch({ type: types.SET_LOCAL_STORAGE_DATE, date }),
      removefavouriteGame: (sportId, gameId, date) => dispatch({
        type: types.REMOVE_FAVOURITES_MATCH, sportId, gameId, date,
      }),
      setFavouritesOnCompetition: () => dispatch({ type: types.SET_FAVOURITES_COMPETITIONS_LIST }),
      getToday: (date, sportId) => dispatch({
        type: types.GET_TODAY_REQUEST,
        date,
        sportId,
      }),
      updateLocalStorage: () => dispatch({ type: types.UPDATE_LOCAL_STORAGE }),
      updateSessionCounter: () => dispatch({ type: types.INCREMENT_SESSION_COUNTER }),
      showTooltip: () => dispatch({ type: types.SHOW_TOOLTIP }),
      hideTooltip: () => dispatch({ type: types.HIDE_TOOLTIP }),
      setIsDifferentTZS: value => dispatch({ type: types.SET_IS_DIFFERENT_TZS, value }),
    },
  }),
)(App);
